var map = {
	"./chatBarController.js": 2162,
	"./chatController.js": 3607,
	"./detailsController.js": 6443,
	"./dialogController.js": 3617,
	"./dialogHeaderController.js": 3848,
	"./dialogMessagesController.js": 3341,
	"./dialogsController.js": 2928,
	"./friendsController.js": 6340,
	"./linkCardController.js": 5300,
	"./linkCardMessagesController.js": 8775,
	"./playTogetherController.js": 6893,
	"./userConversationInfoController.js": 4549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1351;